import { DataFrame, Method, Status } from "lavva.exalushome/build/js/DataFrame";
import { IDevice } from "lavva.exalushome/build/js/Services/Devices/IDevice";
import { ResponseResult } from "lavva.exalushome/build/js/Services/FieldChangeResult";
import { GlobalTimeParameters, IInputOutputSwitchParameters, InputModeSwitch, InputOutputSwitchParameters, ReactionToInput, ReactionToInputSwitchParams } from "../Common/OnOffSwitchConfigurations/OnOffSwitchParameters";
import { OnOffSwitchService, SwitchConfigurationErrorCode } from "../Common/OnOffSwitchConfigurations/OnOffSwitchService";
import { ISlr22ConfigService } from "./ISlr22ConfigService";
import { LedControllerService } from "../Common/LedControllersConfigurations/LedControllerService";

export class Slr22ConfigService extends LedControllerService implements ISlr22ConfigService {
    public static readonly ServiceName: string = "Slr22ConfigService";

    constructor() {
        super();
    }

    GetServiceName(): string {
        return Slr22ConfigService.ServiceName;
    }

    override async SetTurnOnTimeAsync(device: IDevice, params: GlobalTimeParameters): Promise<Status> {

        if ((params.Time.Hours > 0 || params.Time.Minutes > 4) || (params.Time.Minutes >= 4 && params.Time.Seconds > 0)) {
            this._logger.Error(OnOffSwitchService.ServiceName, `Failed to turn on time - time must be in range between 0 and 240 seconds.`);
            return Status.WrongData;
        }

        return super.SetTurnOnTimeAsync(device, params);
    }

    override async SetSwitchInputOutputParamAsync(device: IDevice, params: InputOutputSwitchParameters): Promise<Status> {

        if (params.ReactionToInput == ReactionToInput.Off
            || params.ReactionToInput == ReactionToInput.On
            || params.ReactionToInput == ReactionToInput.OnOff
            || params.ReactionToInput == ReactionToInput.None) {

            if (params.InputMode == InputModeSwitch.Bistable) {
                let currentParams = await super.GetSwitchInputOutputParamAsync(device, params.Channel);

                if ((currentParams as ResponseResult<SwitchConfigurationErrorCode>).Type != null) {
                    this._logger.Error(OnOffSwitchService.ServiceName, `Failed to get current configuration of SLR-22`);
                    return Status.Error
                }

                let currentParam = (currentParams as IInputOutputSwitchParameters[]).firstOrDefault(x => x.InputChannel == params.InputChannel);

                if (currentParam == null)
                    return Status.Error

                if (params.ReactionToInput != ReactionToInput.None && currentParam.ReactionToInput != params.ReactionToInput) {
                    this._logger.Error(OnOffSwitchService.ServiceName, `Failed to set input/output parameters - reaction to input cannot be change when mode is Bistable.`);
                    return Status.WrongData;
                }

                params.ReactionToInput = currentParam.ReactionToInput;
            }

            return super.SetSwitchInputOutputParamAsync(device, params);
        } else {
            this._logger.Error(OnOffSwitchService.ServiceName, `Failed to set reaction to input, SLR-22 allows to set: On, Off or OnOff`);
            return Status.WrongData;
        }
    }

    override async SetSwitchInputOutputReactionToInputParamAsync(device: IDevice, params: ReactionToInputSwitchParams): Promise<Status> {

        if (params.ReactionToInput == ReactionToInput.Off
            || params.ReactionToInput == ReactionToInput.On
            || params.ReactionToInput == ReactionToInput.OnOff) {
            this._logger.Error(OnOffSwitchService.ServiceName, `Failed to set reaction to input, SLR-22 allows to set: On, Off or OnOff`);
            return Status.WrongData;
        }
        return super.SetSwitchInputOutputReactionToInputParamAsync(device, params);
    }
}